import Settings from "./settings";
import Events from "./events.service";
// import Helpers from "./helpers";

var UserWay = {};

var UserWayCache = null;

var button_map = {
	"userway-s3": "Conrast",
	"userway-s4": "Bigger text",
	"userway-s6": "Highlight links",

	"userway-s7": "Dyslexia",
	"userway-s15": "Dyslexia",

	"userway-s2": "Cursor",
	"userway-s16": "Cursor",
	"userway-s10": "Cursor",

	"userway-s12": "Tooltips",
	"userway-s13": "Animations",
	"userway-s14": "Text spacing",

	"userway-s17": "Line height",
	"userway-s19": "Text align",

	"userway-s25": "Hide images",

};

var keys = false;

// body .uwy.userway_p1 .uai

UserWay.addScript = (account_id) => {

	// let pos = Helpers.isMobile()? 5: 1;
	
	(function(d) {
		var s = d.createElement("script");
		/* uncomment the following line to override default position*/
		// s.setAttribute("data-position", pos);
		/* uncomment the following line to override default size (values: small, large)*/
		/* s.setAttribute("data-size", "small");*/
		/* uncomment the following line to override default language (e.g., fr, de, es, he, nl, etc.)*/
		/* s.setAttribute("data-language", "language");*/
		/* uncomment the following line to override color set via widget (e.g., #053f67)*/
		s.setAttribute("data-color", "#E10A0A");
		/* uncomment the following line to override type set via widget (1=person, 2=chair, 3=eye, 4=text)*/
		/* s.setAttribute("data-type", "1");*/
		/* s.setAttribute("data-statement_text:", "Our Accessibility Statement");*/
		/* s.setAttribute("data-statement_url", "http://www.example.com/accessibility")";*/
		/* uncomment the following line to override support on mobile devices*/
		/* s.setAttribute("data-mobile", true);*/
		/* uncomment the following line to set custom trigger action for accessibility menu*/
		/* s.setAttribute("data-trigger", "triggerId")*/
		s.setAttribute("data-account", account_id);
		s.setAttribute("src", "https://cdn.userway.org/widget.js");
		(d.body || d.head).appendChild(s);
	})(document);
};

UserWay.addListener = () => {
	window.addEventListener("message", (event) => {
		if (event.origin === "https://cdn.userway.org") {
			if (event.data && event.data["action"] === "setProperties") {
				if (!UserWayCache && event.data["settings"]) {
					UserWayCache = event.data["settings"];
				}

				let diff = UserWay.getDiff(event.data["settings"]);
				if (diff) {
					let which_button = UserWay.getButtonName(diff);
					// Events.user_interacts_with_accessibility_options(which_button);
					Events.when_user_interacts_with_accessibility_options(
						which_button, event.currentTarget.navigator.language
					);
				}

				UserWayCache = event.data["settings"];
			}
		}
	});
};

UserWay.getDiff = (neww) => {
	if (!keys) {
		keys = Object.keys(UserWayCache);
	}
	for (let key of keys) {
		if (UserWayCache[key]["value"] !== neww[key]["value"]) {
			return key;
		}
	}
	return false;
};

UserWay.getButtonName = (setting_name) => {
	return button_map[setting_name] || "Unmapped setting";
};

UserWay.addWidget = () => {
	if (Settings.userway_account_id) {
		UserWay.addScript(Settings.userway_account_id);
		UserWay.addListener();
	}
};
UserWay.removeWidget = () => {
	const widgetScript = document.querySelector('script[src="https://cdn.userway.org/widget.js"]');
	if (widgetScript) {
			widgetScript.parentNode.removeChild(widgetScript);
	}
};
export default UserWay;
